import { takeEvery, call, put } from 'redux-saga/effects';
import {
  DOWNLOAD_LOG_REQUEST,
  downloadLogSuccess,
  downloadLogFailure
} from './actions';
import { downloadLog } from '../api/logDownloadApi';

function* handleDownloadLog(action) {
  try {
    const blob = yield call(downloadLog, action.date);
    yield put(downloadLogSuccess(blob));
    // Trigger file download in browser
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${action.date}.log`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    yield put(downloadLogFailure(error.message || 'Failed to download log.'));
  }
}

export default function* adminSagas() {
  yield takeEvery(DOWNLOAD_LOG_REQUEST, handleDownloadLog);
}
